module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gb1Am"))).then(() => parcelRequire('2KbAe'));